export const METRICS = ['revenue', 'download'];
export const ALL_METRICS = ['revenue', 'download', 'game_count'];
export const ALL_PLATFORMS = ['All'];
export const PLATFORMS = ['appstore', 'googleplay'];
export const MAX_CHECKED_NUMBER = 10;
// export const MAX_CHECKED_NUMBER = 6;

export const METRICS_MAP = {
  revenue: 'dbi_revenue_$',
  download: 'dbi_downloads',
  game_count: 'dbi_market_total_game',
};

// 临时主品类筛选器选项
export const MAIN_GENRE_OPTIONS = [
  {
    text: 'RPG',
    textCN: 'RPG',
    value: 'RPG',
  },
  {
    text: 'Casino',
    textCN: 'Casino',
    value: 'Casino',
  },
  {
    text: 'Strategy',
    textCN: 'Strategy',
    value: 'Strategy',
  },
  {
    text: 'Racing',
    textCN: 'Racing',
    value: 'Racing',
  },
  {
    text: 'Software',
    textCN: 'Software',
    value: 'Software',
  },
  {
    text: 'Sports',
    textCN: 'Sports',
    value: 'Sports',
  },
  {
    text: 'Gacha',
    textCN: 'Gacha',
    value: 'Gacha',
  },
  {
    text: 'Action',
    textCN: 'Action',
    value: 'Action',
  },
  {
    text: 'Casual',
    textCN: 'Casual',
    value: 'Casual',
  },
  {
    text: 'Shooter',
    textCN: 'Shooter',
    value: 'Shooter',
  },
  {
    text: 'Simulation',
    textCN: 'Simulation',
    value: 'Simulation',
  },
  {
    text: 'Adventure',
    textCN: 'Adventure',
    value: 'Adventure',
  },
];
